module.exports = __webpack_public_path__ + "static/images/Alf/unnamed.png";